import type { Node } from "interfaces/schemas";
import type { NodeApi } from "@hogartrabe/react-arborist-vrh";

type WalkTreeNode = NodeApi<Node>;

type WalkTreeArgs = {
  node: WalkTreeNode;
  childAccessor?: (node: WalkTreeNode) => WalkTreeNode[] | null;
  callback: (node: WalkTreeNode) => void;
  skipChildren?: (node: WalkTreeNode) => boolean;
};

export const walkTree = ({
  node,
  skipChildren,
  callback,
  childAccessor = (args) => args.children ?? [],
}: WalkTreeArgs): void => {
  if (!node) return;

  callback(node);

  if (
    skipChildren &&
    typeof skipChildren === "function" &&
    skipChildren(node)
  ) {
    return;
  }
  const nodes = childAccessor(node);
  if (nodes) {
    nodes.forEach((n) => {
      walkTree({ node: n, childAccessor, callback, skipChildren });
    });
  }
};
